import React from "react"

import Layout from "../components/global/Layout"
import Hero from "../components/block/Hero"
import SEO from "../components/global/SEO"
import CardFeature from "../components/block/CardFeature"
import StepFeature from "../components/block/StepFeature"
import Card from "../components/block/Card"
import {
  faBars,
  faMobileAlt,
  faUsers,
} from "@fortawesome/pro-duotone-svg-icons"

export default function HowWeDoItPage() {
  return (
    <div>
      <Layout>
        <SEO
          title="In-depth, remote user testing"
          description="By testing wireframes, prototypes and live solutions with real users, we generate insights that will inform your design decisions."
        />
        <Hero
          title="In-depth, remote user testing"
          content="By testing wireframes, prototypes and live solutions with real users, we generate insights that will inform your design decisions."
          copyWidth="600px"
        />
        <StepFeature />
        <CardFeature
          backgroundColorOverride={props => props.theme.shade[90]}
          postContent="Feel free to get in touch for a completely no-obligation discussion about how we might be able to help."
          buttonText="Get in touch"
          buttonLink="/contact/"
          cards={
            <>
              <Card icon={faMobileAlt}>
                <h3>On which devices can I test?</h3>
                <p>
                  You can test your design on computers, tablets and mobiles.
                </p>
              </Card>
              <Card icon={faBars}>
                <h3>At what stage can I test?</h3>
                <p>
                  You can user test initial ideas, early designs, a prototype or
                  live solution.
                </p>
              </Card>
              <Card icon={faUsers}>
                <h3>With how many users should I test?</h3>
                <p>
                  Testing with just 5 to 6 users will usually identify all major
                  Issues.
                </p>
              </Card>
            </>
          }
        />
      </Layout>
    </div>
  )
}
